<mat-card>
    <h2>Total de votantes</h2>
    <label style="padding-left: 0.5em;">{{totalVoters}}</label>
</mat-card>
